import { useEffect } from 'react';

import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';
import { ReportSummaryResponse } from '@/modules/Reports/report.types';

import { useGetEmployerIdParam } from '../../hooks';
import { useBaseReportSummaryQuery } from '../../queries';
import { ParticipantAccountActivitySummaryReportParams } from '../ParticipantActivityReport.types';

export const QUERY_KEY = 'REPORT_PARTICIPANT_ACCOUNT_ACTIVITY_SUMMARY';
const useParticipantAccountActivityReportSummaryQuery = (
  params: ParticipantAccountActivitySummaryReportParams
) => {
  const getEmployerIdParam = useGetEmployerIdParam();
  const employerId = getEmployerIdParam(params.employerId, params.employerIds);

  const {
    data,
    isLoading,
    isLoadingMore,
    isSuccess,
    isEmptyData,
    lastTimeUpdateDate,
    planOptions,
    isEmptyPlanOptions,
    isHasNextPage,
    handleLoadMore,
    resetPagination,
  } = useBaseReportSummaryQuery<ReportSummaryResponse>(
    params.isMultipleEmployer
      ? API_URL.REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_MULTI_EMPLOYERS_SUMMARY
      : API_URL.REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_SUMMARY,
    [
      QUERY_KEY,
      params.employerId,
      params?.planYearPeriod,
      params?.planIds.join(','),
      params.employerIds?.join(','),
    ],
    {
      ...employerId,
      plan_year_period:
        params?.planYearPeriod && !params?.planYearPeriod.includes(ALL_OPTION_KEY)
          ? params?.planYearPeriod.join(',')
          : undefined,
      plan_ids:
        params?.planIds && !params?.planIds.includes(ALL_OPTION_KEY) ? params?.planIds.join(',') : undefined,
    },
    {
      isMultipleEmployers: params.isMultipleEmployer,
      employerId: params.employerId,
      employerIds: params.employerIds,
    }
  );

  const planYearPeriodKey = params?.planYearPeriod?.join(',');
  const planIdsKey = params?.planIds.join(',');
  const employerIdsKey = params.employerIds?.join(',');

  useEffect(() => {
    resetPagination();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.employerId, planYearPeriodKey, planIdsKey, employerIdsKey]);

  return {
    lastTimeUpdateDate,
    planOptions,
    isEmptyPlanOptions,
    data,
    isLoading,
    isLoadingMore,
    isSuccess,
    isEmptyData,
    isHasNextPage,
    handleLoadMore,
  };
};

export default useParticipantAccountActivityReportSummaryQuery;
